import { NgModule } from '@angular/core';
import { RippleGridBackgroundComponent } from './ripple-grid-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        RippleGridBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        RippleGridBackgroundComponent
    ]
})
export class NcRippleGridBackgroundModule { }